<template>
    <Attr :widget_id="widget_id" :attr_id="attr_id" :initialAttr="initialAttr">
        <!-- IE 2026 09 24 / ODOO-… (заказ Игоря: объяснения записей) · R2: наведение — объяснение записи-значения запрашивается заранее (recHelp_warm), ответ перерисовывает подсказку -->
        <div class="attr-link wj-control" v-wjTooltip="tooltip()" :style="attr.cssStyle||'max-width: 25rem !important;'"
            @contextmenu.prevent="ctxOpen($event)"
            @mouseenter="recHelp_warm($event)"
        >
            <div :class="cssClass()"
            v-if="attr.use !== false"
            >
                <!-- IE 2026 08 28 / ODOO-5828 (заказ Игоря): «список значений» — CSV чипсами, см. AttrStr -->
                <div v-if="asList" class="attr-element attr-vlist" :class="attr.cssClass" :id="attr.html_id">
                    <span v-for="(v, i) in listValues" :key="i" class="vlist-chip" :title="v" @click="drillVal(v)">
                        <span class="vlist-chip-text">{{ valTitle(v) }}</span>
                        <i v-if="!isReadOnly" class="pi pi-times-circle vlist-chip-x" @click.stop="removeVal(i)"></i>
                    </span>
                    <span v-if="!isReadOnly" class="vlist-add">
                        <input class="vlist-input" v-model="addText" placeholder="+"
                            @focus="dropOpen = true" @blur="dropClose()"
                            @keydown.enter.prevent="addRaw()" @keydown.esc="dropOpen = false" />
                        <div v-if="dropOpen && dropItems.length" class="vlist-drop">
                            <div v-for="it in dropItems" :key="it.id" class="vlist-drop-item"
                                @mousedown.prevent="addVal(it.id)">{{ it.title || it.id }}</div>
                        </div>
                    </span>
                </div>
                <wj-auto-complete v-else
                    :class="'link-control attr-element '+attr.cssClass"
                    :id="attr.html_id"
                    :isReadOnly="isReadOnly"
                    :selectedIndexChanged="selectedIndexChanged"
                    :initialized="initialized"
                    :lostFocus="lostFocus"
                    :selectedValue="doc[binding]"
                    :selectedValuePath="'id'"
                    :displayMemberPath="'title'"
                    :formatItem="formatItem"
                    :maxItems="21"
                    :handleWheel="false"
                    v-wjContextMenu="'ContextWidgetMenuId'"
                    :showDropDownButton="false"
                >
                    <div class="link-buttons">
                        <span wj-part="btn" class="wj-input-group-btn" v-if="attr.relation_segment && !isReadOnly && (!('showListButton' in attr)||attr.showListButton) && !attr.itemsSource">
                            <!-- IE 2026 09 23 / ODOO-341407: i18n -->
                            <button class="wj-btn wj-btn-default attr-link-button" @click="onСhoice__Click" tabindex="-1" type="button" :aria-label="t('Toggle choose in list')">
                                <i class="pi pi-doc pi-ellipsis-h"></i>
                            </button>
                        </span>
                        <span wj-part="btn" class="wj-input-group-btn" v-if="attr.itemsSource || (attr.relation_segment && (!isReadOnly))">
                            <button class="wj-btn wj-btn-default attr-link-button" @click="onButtonShowDroppedDown__Click" tabindex="-1" type="button" :aria-label="t('Drop down')">
                                <i class="pi pi-doc pi-angle-down"></i>
                            </button>
                        </span>
                        <!-- IE 2026 10 26 / ODOO-5800 (слово Igor 26.10 через ie-dm7 #106001: AttrLink составного типа 1С — резолв по relation_segments по очереди): кнопка открытия — и у поля составного типа, когда id найден в одном из relation_segments -->
                        <span wj-part="btn" class="wj-input-group-btn" v-if="(attr.relation_segment || mtlSeg) && (!('showOpenButton' in attr)||attr.showOpenButton)">
                            <button class="wj-btn wj-btn-default attr-link-button" @click="onButtonOpen__Click" tabindex="-1" type="button" :aria-label="t('Internal link')">
                                <i class="pi pi-doc pi-arrow-right"></i>
                            </button>
                        </span>
                    </div>
                </wj-auto-complete>
                <label v-if="isLabeled && attr.title && !attr.hideTitle" :for="attr.html_id">{{ attr.title }}</label>
            </div>
            <div v-if="ctx.show" class="vlist-ctx" :style="{ left: ctx.x + 'px', top: ctx.y + 'px' }"
                @mouseleave="ctx.show = false">
                <!-- IE 2026 09 23 / ODOO-341407: i18n -->
                <div class="vlist-ctx-item" @click="toggleList()">{{ asList ? t('Present as plain text') : t('Present as a value list') }}</div>
            </div>
        </div>
    </Attr>
</template>

<script>
import { useMainStore, ADMIN_DICT_SEGMENTS } from '@/stores/mainStore'
import recordHelp from '@/utils/recordHelp'   // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснения записей) · R2: ссылочное поле формы
import { mtl_segments, mtl_resolve, mtl_subscribe } from '@/utils/multiTypeLinks'   // IE 2026 10 26 / ODOO-5800 (слово Igor 26.10 через ie-dm7 #106001: AttrLink составного типа 1С — резолв по relation_segments по очереди)

export default {
    props: [
        'widget_id',
        'attr_id',
        'initialAttr',
    ],
    data: () => ({
        attr: {},
        WIDGET: {},
        input: null,
        // itemsSource: [],
        doc: {},
        binding: '',
        buttons_innerHTML: '',
        addText: '',
        dropOpen: false,
        ctx: { show: false, x: 0, y: 0 },
        mtlSeg: '',   // IE 2026 10 26 / ODOO-5800 (слово Igor 26.10 через ie-dm7 #106001: AttrLink составного типа 1С — резолв по relation_segments по очереди): сегмент, в котором найден id поля составного типа (кнопка и открытие записи)
    }),
    setup() {
        const store = useMainStore()
        return { store }
    },
    created() {
        // console.log(`created ${this.attr_id}`)
        this.WIDGET = this.store.findWidget(this.widget_id).WIDGET
        this.content_Changed()
    },
    beforeUnmount() {
        this.store.attr_deregister(this)
        this._mtlUnsub?.(); this._mtlUnsub = null   // IE 2026 10 26 / ODOO-5800 (слово Igor 26.10 через ie-dm7 #106001: AttrLink составного типа 1С — резолв по relation_segments по очереди)
    },
    methods: {
        // ---- IE 2026 08 28 / ODOO-5828: режим «список значений» (см. AttrStr) ----
        ctxOpen(e) {
            this.ctx = { show: true, x: e.clientX, y: e.clientY }
        },
        toggleList() {
            this.ctx.show = false
            const b = this.attr?.binding
            if (b == null) return
            this.store.set_viewParam(this.WIDGET, 'value_as_list', b, !this.asList)
        },
        valTitle(v) {
            const it = this.listItems.find(x => String(x.id) === String(v))
            if (it) return it.title || v
            const seg = this.attr?.relation_segment
            const reg = seg ? this.store.itemsSource?.[seg] : null
            const ri = (reg?.items || reg?.itemsSource || []).find?.(x => String(x?.id) === String(v))
            return ri?.title || v
        },
        applyList(arr) {
            const csv = arr.join(',')
            if ((this.store.get_value(this.doc, this.binding) ?? '') !== csv) {
                this.store.attr_set(this.WIDGET, this.attr, csv)
            }
        },
        removeVal(i) {
            const arr = this.listValues.slice()
            arr.splice(i, 1)
            this.applyList(arr)
        },
        addVal(id) {
            id = String(id ?? '').trim()
            if (!id) return
            const arr = this.listValues.slice()
            if (!arr.includes(id)) arr.push(id)
            this.applyList(arr)
            this.addText = ''
            this.dropOpen = false
        },
        addRaw() {
            const t = this.addText.trim()
            if (!t) return
            const it = this.dropItems[0]
            this.addVal(it ? it.id : t)
        },
        dropClose() {
            setTimeout(() => { this.dropOpen = false }, this.store?.setting('fe.ux.hoverHideMs', 150) ?? 150)   // IE 2026 09 05 / ODOO-336330
        },
        drillVal(v) {
            const it = this.listItems.find(x => String(x.id) === String(v))
            const seg = it?.segment || this.attr?.relation_segment
            if (!seg) return
            this.store.widget_open({
                doc: { id: v, segment: seg, relation_binding: this.attr?.relation_binding },
                widget: 'widget-record',
                parentAction: { 'action_name': 'action-front-vlist', method: 'AttrLink.drillVal' },
            }, this)
        },
        content_Changed() {
            if (this.initialAttr) {
                // attr передан объектом — id в поиске не участвует (опционален);
                // регистрацию в реестре по id сохраняем (choiceFinish ищет по ней)
                this.attr = this.initialAttr
                if (this.attr_id != null) {
                    this.WIDGET.attrs_vueObj[this.attr_id] = this
                }
            } else {
                this.store.widget_attr_set(this)
            }
            if (this.attr?.use === false) {
                return
            }

            if (this.input) {
                const [doc, binding] = this.store.attr_get_link(this.WIDGET, this.attr)
                this.doc = doc, this.binding = binding

                // get_itemsSource && set item
                // let item = this.store.attr_get(this.WIDGET, this.attr)
                const value = this.store.get_value(this.doc, this.binding)
                // IE 2026 09 23 / ODOO-… (находка пробы selframe_check): статичный список поля (attr.itemsSource) — локальный, запрашивать по id
                // нечего: с ids = [value] при ПУСТОМ значении ids оставался не null и get_itemsSource не отдавал список контролу
                // (input.itemsSource = []) — выпадающий список не открывался, пока значение не задано. Выключатель fe.ux.linkStaticListLocal.
                const staticList = Array.isArray(this.attr.itemsSource) && this.attr.itemsSource.length > 0 && this.store.setting('fe.ux.linkStaticListLocal', true) !== false
                // IE 2026 10 26 / ODOO-5800 (слово Igor 26.10 через ie-dm7 #106001: AttrLink составного типа 1С — резолв по relation_segments по очереди): составной тип (relation_segments без relation_segment) — свой резолв по сегментам по очереди; запрос без сегмента не уходит
                if (staticList || !this.mtl_refresh(value)) this.store.get_itemsSource(this, this.input, this.attr, staticList ? { fetchMode: 'justGet' } : { ids: [ value ] })

                // ODOO-3216: admin-словари (крошечные) — одноразовый session
                // full-fetch: в by_ids-режиме itemsSource держит только уже
                // резолвленные id, и дропдаун/типизация в формах пусты
                // (Provision VM: Server type / Location). Дедуп — по
                // fetchMode/_pending_fetchMode='all' (очередь get_itemsSource).
                const segment = this.attr.relation_segment
                if (segment && ADMIN_DICT_SEGMENTS.includes(segment)) {
                    const its = this.store.itemsSource[segment]
                    if (!(its && (its.fetchMode === 'all' || its._pending_fetchMode === 'all'))) {
                        this.store.get_itemsSource(this, this.input, this.attr, { fetchMode: 'all' })
                    }
                }
            }

            // IE 2026 09 23 / ODOO-341407: i18n
            this.attr.groupMenu = {
                cell_buttons: [
                    { 'tooltip': this.t('Open subelements for type'), 'action_name':'action-front-2', 'command':'widget_open', 'widget': 'widget-list', 'cssClass':'pi pi-doc pi-folder-open' },
                    { 'tooltip': this.t('Drop down'), 'command':'DropDown', 'cssClass':'pi pi-doc pi-angle-down' },
                    { 'tooltip': this.t('Edit'), 'action_name':'action-front-3', 'command':'widget_open', 'widget':'widget-record', 'cssClass':'pi pi-doc pi-arrow-right' },
                ]
            }
            if (this.attr.groupMenu && this.attr.groupMenu.cell_buttons) {
                this.buttons_innerHTML = this.store.get_buttons_innerHTML(this.attr.groupMenu.cell_buttons)
            }
        },
        initialized(input) {
            // set input
            this.input = input
            this.content_Changed()
        },
        formatItem(s, e) {
            // console.log('formatItem')
            // if (e.item.tabIndex==0) {
            //     let buttons_innerHTML = ''
            //     if (this.buttons_innerHTML) {
            //         buttons_innerHTML = 
            //         `<div class="data-cell attr-link-button-group wj-control">
            //             ${this.buttons_innerHTML}
            //         </div>`
            //     }
            //     e.item.innerHTML = 
            //     `<div class="attr-link wj-listbox-item wj-state-selected" role="option" aria-selected="true" tabindex="0">
            //         ${e.data.title}
            //         ${buttons_innerHTML}
            //     </div>`
            // } else {
                let dataItem = e.data;
                if (dataItem.category) {
                    e.item.classList.add('category');
                }
                if (dataItem.disabled) {
                    e.item.classList.add('wj-state-disabled');
                }
                if (dataItem.pi) {
                    e.item.innerHTML = `<i class="pi ${dataItem.pi}"></i>${e.item.innerHTML}`
                }
            // }
        },
        selectedIndexChanged(input) {
            if (input.selectedItem && !input.itemsSource_myFreeze) {
                let item = this.store.attr_get(this.WIDGET, this.attr)

                //new value
                if (!item || item !== input.selectedValue) {
                    this.attr_set(input.selectedValue)
                }
            }
        },
        onButtonOpen__Click() {
            // this.input.listBox.showSelection(true)
            let item = this.store.attr_get(this.WIDGET, this.attr)
            if (!item) {
                this.onСhoice__Click()
            } else {
                this.store.widget_open({
                    doc:{ 
                        id:item,
                        segment:this.attr.relation_segment || this.mtlSeg,   // IE 2026 10 26 / ODOO-5800 (слово Igor 26.10 через ie-dm7 #106001: AttrLink составного типа 1С — резолв по relation_segments по очереди)
                        relation_binding:this.attr.relation_binding,
                    },
                    widget: 'widget-record',
                    parentAction: { 'action_name':'action-front-4', method: 'AttrLink.onButtonOpen__Click' },
                }, this)
            }
        },
        onСhoice__Click() {
            let item = this.store.attr_get(this.WIDGET, this.attr)
            this.store.open_widgetList_forAttr(item, 
                this.attr,
                {'action_name':'action-front-9-2', method: 'AttrLink.onСhoice__Click', params:{isChoise:true}}, 
                this
            )
        },
        choiceFinish(attr, item) {
            this.attr_set(item.id)
            this.input.hostElement.focus()
        },
        attr_set(id) {
            this.store.attr_set(this.WIDGET, this.attr, id)
        },
        lostFocus(input) {
            let newVal = input.text
            if (!input.selectedItem && this.mtlKeep(input)) return   // IE 2026 10 26 / ODOO-5800 (слово Igor 26.10 через ie-dm7 #106001: AttrLink составного типа 1С — резолв по relation_segments по очереди): сырой id поля составного типа уход фокуса не стирает
            if (!input.selectedItem) {
                this.attr_set('')
                input.text = ''
                // let item = this.store.attr_get(this.WIDGET, this.attr)

                // //restore current value
                // if (item && 'title' in item && newVal && item.title.toLowerCase().includes(newVal.toLowerCase())) {
                //     input.text = item.title
                //     return
                // }

                // //find bestMatch
                // let itemsSource = this.input.itemsSource
                // if (newVal && itemsSource && itemsSource.length) {
                //     let bestMatch = this.store.findMatch(newVal, itemsSource)
                //     if (bestMatch!=-1) {
                //         input.text = itemsSource[bestMatch].title
                //         return
                //     }
                // }
                
                // //clear
                // if (newVal) {
                //     input.text = ''
                // }
                // if (item) {
                //     this.attr_set('')
                // }
            }
        },
        // IE 2026 10 26 / ODOO-5800 (слово Igor 26.10 через ie-dm7 #106001: AttrLink составного типа 1С — резолв по relation_segments по очереди):
        // поле составного типа 1С — id ищется по relation_segments по очереди (utils/multiTypeLinks): найден — словарь ТОГО сегмента в контрол (название,
        // кнопка открытия записи); ждём ответа / не найден ни в одном — сырой id, как у одиночной ссылки без названия. false — поле не составное или
        // выключатель fe.ux.multiTypeLinks выкл.: прежний путь
        mtl_refresh(value) {
            const segs = mtl_segments(this.attr, this.store)
            if (!segs) { if (this.mtlSeg) this.mtlSeg = ''; return false }
            if (!this._mtlUnsub) {
                this._mtlUnsub = mtl_subscribe(this.store, (seg) => {
                    const s2 = mtl_segments(this.attr, this.store)
                    if (this.input && s2 && s2.includes(seg)) this.mtl_refresh(this.store.get_value(this.doc, this.binding))
                })
            }
            const input = this.input
            if (!input) return true
            const r = mtl_resolve(this.store, segs, value, this)
            const found = r.state === 'found' ? r.segment : ''
            if (this.mtlSeg !== found) this.mtlSeg = found
            if (r.state === 'none') return true
            input.itemsSource_myFreeze = true
            try {
                if (found) {
                    // штатный путь одиночной ссылки: input.itemsSource = словарь сегмента, selectedValue сохраняется → название
                    this.store.get_itemsSource({ WIDGET: this.WIDGET }, input, { attr_type: 'AttrLink', relation_segment: found, binding: this.attr.binding }, { fetchMode: 'justGet' })
                    input.itemsSource_myFreeze = true
                    if (input.selectedValue !== value) input.selectedValue = value
                } else if (value && (input.collectionView ? input.selectedValue !== value : input.text !== String(value))) {
                    input.itemsSource = null   // без словаря wijmo показывает значение текстом — сырой id
                    input.selectedValue = value
                }
            } finally {
                input.itemsSource_myFreeze = false
            }
            return true
        },
        mtlKeep(input) {
            if (!mtl_segments(this.attr, this.store)) return false
            const v = this.store.get_value(this.doc, this.binding)
            return !!v && String(input.text ?? '') === String(v)
        },
        onButtonShowDroppedDown__Click() {
            this.input.isDroppedDown = !this.input.isDroppedDown
        },
        cssClass() {
            const base = this.attr['inputClass'] || (this.isLabeled ? 'wj-labeled-input' : '')
            return `${base} attr-link-input`.trim()
        },
        // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснения записей) · R2: ссылочное поле формы: наведение — объяснение записи-значения запрашивается заранее (пачкой, utils/recordHelp); пришёл ответ —
        // поле перерисовывается (подсказка статичная, v-wjTooltip: строки записи — store.tooltip_attr из кэша) и видимая подсказка обновляется
        recHelp_warm(e) {
            const tgt = this.store.recordHelp_linkTarget(this)
            if (!tgt) return
            const el = e && e.currentTarget
            recordHelp.warm(tgt.id, tgt.segment, () => { this.$forceUpdate(); this.$nextTick(() => recordHelp.reshowOwner(el)) })
        },
        tooltip() {
            // IE 2026 09 23 / ODOO-341407: i18n
            const tooltip2 = `<b class='tooltip-header'>${this.t('id:')}</b> <b class='tooltip-text'> ${this.doc[this.binding]}</b>`
            return this.store.tooltip_attr(this, tooltip2)
        },
    },
	computed: {
        asList() {
            const b = this.attr?.binding
            const vp = this.WIDGET?.record?.doc?.viewParams?.value_as_list
            const f = (vp && b != null) ? vp[b] : undefined
            if (f !== undefined) return !!f
            // IE 2026 08 28 / ODOO-5828 (заказ Игоря): несколько значений — чипсами по умолчанию
            return !!this.attr?.as_list || this.listValues.length > 1
        },
        listValues() {
            return String(this.store.get_value(this.doc, this.binding) ?? '').split(',').map(s => s.trim()).filter(Boolean)
        },
        listItems() {
            return (this.attr?.itemsSource || []).filter(x => x && x.id != null)
        },
        dropItems() {
            const t = this.addText.trim().toLowerCase()
            const have = this.listValues
            return this.listItems
                .filter(x => !have.includes(String(x.id)))
                .filter(x => !t || String(x.title || '').toLowerCase().includes(t) || String(x.id).toLowerCase().includes(t))
                .slice(0, 12)
        },

        isLabeled() {
            return this.attr.labeled !== false
        },
        isReadOnly() {
            return this.WIDGET?.isReadOnly||this.attr?.isReadOnly||this.attr?.fieldMapping?.use||false
        },
	},
    watch: {
        initialAttr(attr) {
            // ремоунта нет, если :key совпал — подхватываем новый объект вручную
            if (attr) { this.content_Changed() }
        },
        'store.itemsSource_change_index'(newVal, oldVal) {
            const changedSet = this.store.get_itemsSource_changedSet(newVal, oldVal)
            const _mtlSegs = this.input ? mtl_segments(this.attr, this.store) : null   // IE 2026 10 26 / ODOO-5800 (слово Igor 26.10 через ie-dm7 #106001: AttrLink составного типа 1С — резолв по relation_segments по очереди)
            if (_mtlSegs && (changedSet === null || _mtlSegs.some(s => changedSet.has(s)))) { this.mtl_refresh(this.store.get_value(this.doc, this.binding)); return }   // IE 2026 10 26 / ODOO-5800 (слово Igor 26.10 через ie-dm7 #106001: AttrLink составного типа 1С — резолв по relation_segments по очереди)
            if (this.attr.relation_segment && (changedSet === null || changedSet.has(this.attr.relation_segment))) {
                // console.log(`watch ${this.store.itemsSource.change_type} ${newVal}`)
                this.store.get_itemsSource(this, this.input, this.attr, {fetchMode: 'justGet'})
            }
        }
    },
}
</script>

<style>
.attr-link {
    width:-webkit-fill-available;
    display: flex;
}
.attr-link-input {
    width:-webkit-fill-available !important;
}
.attr-link .attr-link-button {
    transition: all 250ms;
    opacity: 0;
    color: lightslategray !important;
    /* display: flex; */
    /* align-items: center; */
}
.attr-link:hover .attr-link-button {
    opacity: 1;
}
.cell-value .attr-link-button {
    opacity: 1;
}
.attr-link-button {
    border-radius: 6px;
}
.wj-listbox-item.category {
    padding-top: 4px;
    padding-left: 5px;
    font-size: 120%;
    font-weight: bold;
    background: #f0f0f0;
    color: #808080;
    position: sticky;
    top: 0;
    opacity: 1;
}
.wj-listbox-item .pi {
    padding-right: 6px;
}
.link-buttons {
    position: absolute;
    right: 0;
    transition: all 250ms;
    opacity: 0;
    color: lightslategray !important;
    background: transparent;
    z-index: 1;
}
.link-buttons .pi {
    text-shadow:
            /* many shadows blur out the area around the text */
            0 0 1px white,
            0 0 2px white,
            0 0 3px white,
            0 0 4px white,
            0 0 5px white,
            0 0 6px white,
            0 0 7px white,
            0 0 8px white,
            0 0 9px white,
            0 0 10px white;
}
.link-control:hover .link-buttons {
    opacity: 0.9;
}
/* IE 2026 08 28 / ODOO-5828: список значений (копия стилей AttrStr) */
.attr-vlist {
    display: flex; flex-wrap: wrap; align-items: center; gap: 3px;
    min-height: 1.6rem; padding: 2px 0 1px 0;
    border-bottom: 1px solid var(--surface-border, #cbd5e1);
}
.vlist-chip {
    display: inline-flex; align-items: center; gap: 4px;
    padding: 1px 7px; border-radius: 10px; cursor: pointer;
    background: var(--highlight-bg, #eef2ff); border: 1px solid var(--surface-border, #c7d2fe);
    font-size: .85em; line-height: 1.35; max-width: 14rem;
}
.vlist-chip-text { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.vlist-chip-x { font-size: .85em; opacity: .55; }
.vlist-chip-x:hover { opacity: 1; }
.vlist-add { position: relative; flex: 1 0 3rem; min-width: 3rem; }
.vlist-input {
    width: 100%; border: none; outline: none; background: transparent;
    font: inherit; color: inherit; padding: 2px 2px;
}
.vlist-drop {
    position: absolute; left: 0; top: 100%; z-index: 1000; min-width: 12rem; max-height: 16rem; overflow-y: auto;
    background: var(--surface-card, #fff); border: 1px solid var(--surface-border, #cbd5e1);
    border-radius: 4px; box-shadow: 0 4px 14px rgba(0,0,0,.18);
}
.vlist-drop-item { padding: 4px 10px; cursor: pointer; white-space: nowrap; }
.vlist-drop-item:hover { background: var(--highlight-bg, #eef2ff); }
.vlist-ctx {
    position: fixed; z-index: 10000;
    background: var(--surface-card, #fff); border: 1px solid var(--surface-border, #cbd5e1);
    border-radius: 4px; box-shadow: 0 4px 14px rgba(0,0,0,.18); padding: 2px;
}
.vlist-ctx-item { padding: 4px 12px; cursor: pointer; white-space: nowrap; font-size: .9em; }
.vlist-ctx-item:hover { background: var(--highlight-bg, #eef2ff); }
</style>